<div class="wrapper-notifications" (scroll)="onScroll($event)">
  <div *ngFor="let notification of notifications" class="wrapper-notification" (click)="clickOnNotification(notification)" [ngClass]="{'unread': notification.read_at === null}">
    <span class="title-notification">{{ notification.data.data.title }}</span>
    <span class="description-notification">{{ notification.data.data.description }}</span>
    <span class="time-notification">{{ notification.data.created_at | timeAgo }}</span>
  </div>
</div>
